<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="4.75" y="4.75" width="28.5" height="28.5" rx="14.25" :fill="props.iconColor" />
		<rect x="16.9648" y="10.8574" width="4.07143" height="12.2143" rx="2.03571" fill="white" />
		<rect x="16.9648" y="25.1074" width="4.07143" height="4.07143" rx="2.03571" fill="white" />
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 38,
		height: 38,
		iconColor: '#818393',
	}
);
</script>

<style lang="scss" scoped></style>
